module.exports = __webpack_public_path__ + "img/mitp.4dd05875.png";